/**
 * Gestione Sottoscrizioni
 *
 * Contact: bonjoprg@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PendingCashSubscriptionDto { 
    id: number;
    nomeCompleto: string;
    telefono: string;
    /**
     * Importo con due decimali
     */
    importo: string;
    modalitaPagamento: PendingCashSubscriptionDtoModalitaPagamentoEnum;
    dataSottoscrizione: string;
}
export enum PendingCashSubscriptionDtoModalitaPagamentoEnum {
    Contanti = 'CONTANTI',
    Bonifico = 'BONIFICO',
    Pos = 'POS',
    Rid = 'RID'
};



